import { services } from "../../../constants/services";
import { IParams, ResponseQ } from "../../../common/dtos/paginate.dto";
import { getByQuery } from "../../../utils/api";

export const GetCampusWithPaginationService = async (params: IParams) => {
  const response = await getByQuery<ResponseQ<any>>(`${services.rooms}/campus`, params);
  return response;
};